import Strategy from './strategy';
import UnitConfig from '../unitConfig';
import alertOperateUnitModal from '../operateUnitModal';
import EnumOperates from 'src/enums/enumOperates';
import { Toast } from 'src/util/toast';
import UnitGroupApi from '../api/unitGroupApi';

/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-03 19:43:00
 */

export default class UnitGroupService implements Strategy {
    ctx: UnitConfig
    constructor(ctx: UnitConfig) {
        this.ctx = ctx
    }
    async add() {
       let res = await alertOperateUnitModal(EnumOperates.Add.getName(), '因子组')
       if(res) {
            this.searchList()
       }
    }

    async update(item: {id: number, name: string}) {
        let res = await alertOperateUnitModal(EnumOperates.Update.getName(), '因子组', item.id, item.name)
        if(res) {
             this.searchList()
        }
    }

    async init() {
        this.searchItems()
        await this.searchList()
        if(this.ctx.leftData.length>0) {
            this.ctx.currentMenu = this.ctx.leftData[0].id
            this.searchRelationById(this.ctx.currentMenu)
        }
    }

    async delete(id){
        if(!await Toast.confirm()) {return}
        let {code} = await UnitGroupApi.delete(id)
        if(code === 0) {
            if(id === this.ctx.currentMenu) {
                this.init()
            } else{
                this.searchList()
            }
            Toast.success('删除成功')
        }
    }

    async searchList() {
        let {data,code} = await UnitGroupApi.searchList()
        if(code === 0) {
            this.ctx.leftData = data.data_info
        }
    }
    async searchItems(){
        let {data,code} = await UnitGroupApi.searchDataType()
        if(code === 0) {
            this.ctx.rightData = data
        }
    }

    async searchRelationById(id: number) {
        let {data,code} = await UnitGroupApi.searchRelation(id)
        if(code === 0) {
            this.ctx.checkData = data.map(i=> i.component_id)
        }
    }

    async updateRelation(id: number) {
        let {data,code} = await UnitGroupApi.updateRelation(id, this.ctx.checkData)
        if(code === 0) {
            Toast.success('保存成功')
        }
    }
}